import React, { useContext } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import AppContext from '../../../context/Context';

const renderTooltip = (props: any) => (
  <Tooltip id="button-tooltip" {...props}>
    Скрыть/показать меню
  </Tooltip>
);

const ToggleButton = () => {
  const {
    config: { isNavbarVerticalCollapsed },
    setConfig
  } = useContext<any>(AppContext);

  const handleClick = () => {
    document
      .getElementsByTagName('html')[0]
      .classList.toggle('navbar-vertical-collapsed');
    setConfig('isNavbarVerticalCollapsed', !isNavbarVerticalCollapsed);
  };

  return (
    <OverlayTrigger
      placement={'right'}
      overlay={renderTooltip}
      defaultShow={false}
    >
      <div
        className="toggle-icon-wrapper"
        style={{ margin: 0, marginRight: 6 }}
      >
        <Button
          variant="link"
          className="navbar-toggler-humburger-icon navbar-vertical-toggle"
          onClick={handleClick}
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </Button>
      </div>
    </OverlayTrigger>
  );
};

export default ToggleButton;
